module.exports = __webpack_public_path__ + "img/pat-walsh.29f3c8ac.jpg";